<template>
  <div class="monitoring-top-right bg-light p-2 shadow-monitoring">
    <div style="display: flex; height: 80%; width: 100%; overflow: hidden;">
      <div
        class="doughnat-container"
        v-for="(label, index) in labels"
        :key="index"
        v-if="k3lKplhMonitoring"
      >
        <div
          class="flex-column"
          style="display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          max-width: 70px;
          height: 100%;"
        >
          <div class="text-center text-bold" style="font-size:7px;">{{ label }}</div>
          <pie-chart
            :chartData="chart[`chartData${index}`]"
            :options="chart[`chartOptions`]"
            :styles="{ height: '75%' }"
          />
        </div>
        <div class="legend legend-right">
          <ul>
            <li
              v-for="(data, dataIndex) in chart[`chartData${index}`].labels"
              :key="dataIndex"
            >
              <span
                :style="{
                  backgroundColor:
                    chart[`chartData${index}`].datasets[0].backgroundColor[
                      dataIndex
                    ],
                }"
              ></span>
              <div class="legend-label">{{ data }}</div>
              <br />
              <div class="legend-data">
                &nbsp;{{
                  chart[`chartData${index}`].datasets[0].data[dataIndex]
                }}&nbsp;
                <span class="legend-percentage"
                  >({{
                    percenCalc(
                      chart[`chartData${index}`].datasets[0].data[dataIndex],
                      chart[`chartData${index}`].datasets[0].data
                    )
                  }}%)</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PieChart: () => import('@/components/chart/dashboard/pie-chart.vue'),
  },
  data() {
    return {
      labels: ['K3L Status Activity', 'KPLH Status Activity'],
      chart: {
        chartData0: {
          labels: ['Expired', 'Active', 'Expired Soon'],
          datasets: [
            {
              backgroundColor: ['red', 'pink', '#ff914c'],
              data: [60, 25, 15],
            },
          ],
        },

        chartData1: {
          labels: ['Expired', 'Active', 'Expired Soon'],
          datasets: [
            {
              backgroundColor: ['red', 'pink', '#ff914c'],
              data: [60, 25, 15],
            },
          ],
        },

        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: 'right',
            labels: {
              generateLabels(chart) {
                const data = chart.data
                if (data.labels.length && data.datasets.length) {
                  return data.labels.map((label, i) => {
                    const dataset = data.datasets[0]
                    const percentage = Math.round(
                      (dataset.data[i] / dataset.data.reduce((a, b) => a + b)) *
                        100
                    )
                    return {
                      text: `${dataset.data[i]} (${percentage}%) - ${label}`,
                      fillStyle: dataset.backgroundColor[i],
                      hidden:
                        isNaN(dataset.data[i]) ||
                        chart.getDatasetMeta(0).data[i].hidden,
                      lineCap: 'round',
                    }
                  })
                }
                return []
              },
            },
          },
        },
      },
    }
  },
  computed: {
    k3lKplhMonitoring() {
      this.convertData()

      return true
    },
    kplhStatus() {
      const data = this.$store.state.monitoringStore.kplh_status

      return data
    },
    k3lStatus() {
      const data = this.$store.state.monitoringStore.k3l_status

      return data
    },
  },
  methods: {
    percenCalc(datum, data) {
      const total = data.reduce((a, b) => Number(a) + Number(b))
      const percentage =
        total !== 0 ? Math.round((Number(datum) / total) * 100) : 0
      return percentage
    },
    convertData() {
      this.chart = {
        ...this.chart,
        chartData0: {
          labels: ['Expired', 'Active', 'Expired Soon'],
          datasets: [
            {
              backgroundColor: ['red', 'pink', '#ff914c'],
              data: [
                this.k3lStatus.expired,
                this.k3lStatus.active,
                this.k3lStatus.expired_soon,
              ],
            },
          ],
        },
        chartData1: {
          labels: ['Expired', 'Active', 'Expired Soon'],
          datasets: [
            {
              backgroundColor: ['red', 'pink', '#ff914c'],
              data: [
                this.kplhStatus.expired,
                this.kplhStatus.active,
                this.kplhStatus.expired_soon,
              ],
            },
          ],
        },
      }
    },
  },
}
</script>

<style scoped>
.doughnat-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 200px;
  height: 100%;
}
/* .doughnat-container {
  width: 50%;
  height: 100%;
  position: relative;
} */

.legend {
  margin-top: 10px;
  font-size: 0.5rem;
}

.legend ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.legend li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  color: gray;
}

.legend li span:first-child {
  /* display: inline-block; */
  width: 8px;
  height: 8px;
  margin-right: 5px;
}

.legend-label {
  flex: 1;
}

.legend-data {
  flex: 2;
  display: flex;
  /* justify-content: space-between; */
}

.legend-percentage {
  color: gray;
}

/* Add the following styles for positioning the legend */
.legend-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: auto;
  margin-left: 10px;
}
</style>
